import { PhotoPresentationLayout } from '@shared/utils/photoPresentationLayout';

export const getTemplateImageUrl = (filename: string, version: string = '1638397480'): string =>
  `https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/new-websites/${filename}.jpg?v=${version}`;

export const getTemplateDefaultHeaderPhotoUrl = (templateId: string, photoIndex: string = '', version: string = '1638397480'): string =>
  `https://withjoy.com/assets/public/wedding-website/designs-gallery/default-assets/${templateId}${photoIndex}.png?v=${version}`;

export const generateDefaultPhotoData = (id: string, totalPhotoCount: number, width: number, height: number) => {
  return Array.from({ length: totalPhotoCount }, (_, i) => ({
    id: `${id}-${i + 1}`,
    url: getTemplateDefaultHeaderPhotoUrl(id, totalPhotoCount === 1 ? '' : `${i + 1}`),
    height,
    width,
  }));
};

export const deriveDesignTemplateId = (themeId: string, photoPresentationLayout: PhotoPresentationLayout): string => `${themeId}-${photoPresentationLayout}`;
